import React from "react";
import { createRoot } from "react-dom/client";
import UploadMultiple from "./UploadMultiple";
import UploadImage from "./UploadImage";

class UploadModelService {
  constructor() {
    this.modalContainer = null;
    this.root = null;
    this.setupModalContainer();
  }

  setupModalContainer() {
    this.modalContainer = document.createElement("div");
    this.modalContainer.id = "upload-modal-container";
    document.body.appendChild(this.modalContainer);
    this.root = createRoot(this.modalContainer);
  }

  createModal(options) {
    return new Promise((resolve) => {
      const handleClose = () => {
        this.root.render(null);
        resolve({ status: "close", files: [] });
      };

      const handleConfirm = (files) => {
        this.root.render(null);
        resolve({
          status: "confirm",
          files: Array.isArray(files) ? files : [files].filter(Boolean),
        });
      };

      const handleCancel = () => {
        this.root.render(null);
        resolve({ status: "cancel", files: [] });
      };

      const { type = "multiple", ...restOptions } = options;

      const modalProps = {
        isOpen: true,
        toggle: handleClose,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        ...restOptions,
      };

      const modalComponent = type === "image" ? <UploadImage {...modalProps} /> : <UploadMultiple {...modalProps} />;

      this.root.render(modalComponent);
    });
  }

  open({ 
    type = "multiple", 
    title, 
    desc, 
    message, 
    accept, 
    maxFile = type === "image" ? 1 : 0, 
    maxSize, 
    onUploadFile, 
    initFiles = [], 
    onRemoveFile,
    immediateAction = false 
  }) {
    return this.createModal({
      type,
      title,
      desc,
      message,
      accept,
      maxFile: type === "image" ? 1 : maxFile,
      maxSize,
      onUploadFile,
      onRemoveFile,
      initFiles,
      immediateAction,
      ...(type === "image" && { 
        initFile: Array.isArray(initFiles) ? initFiles[0] : initFiles 
      }),
    });
  }

  // Convenience methods
  openMultiple(options) {
    return this.open({ ...options, type: "multiple" });
  }

  openImage(options) {
    return this.open({ ...options, type: "image" });
  }
}

export const upload = new UploadModelService();
